import { LAB_REPORT } from "@/api_framework/api_config";
import { useConfiguration } from "@/app/hooks/useConfiguration";
import { useAppDispatch } from "@/app_redux/hooks/root_hook";
import axios, { AxiosError, AxiosResponse } from "axios";
import { useCallback, useState } from "react";
import AxiosCurlirize from "axios-curlirize";
import { useCurlLogger } from "@/app/hooks/useCurlLogger";

AxiosCurlirize(axios, () => {});

export const useLabTestUpdateListAPI = () => {
  const dispatch = useAppDispatch();
  const { sendCurl } = useCurlLogger();

  const configuration = useConfiguration();
  const execute = useCallback(
    async (paramsBody: any, labPartnerId: string) => {
      try {
        const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
        const response = await axios
          .post(`${LAB_REPORT?.LAB_TEST_LIST?.baseURL}${labPartnerId}/`, paramsBody, {
            headers: {
              Authorization: `${accessToken}`,
              "Content-Type": "application/json",
            },
          })
          .then((res: AxiosResponse<any>) => {
            if (res.data.status === true) {
              return { status: true, message: "" };
            } else {
              return { status: false, message: null };
            }
          })
          .catch((e: AxiosError) => {
            sendCurl(e.config["curlCommand"]);
            return { status: false, message: null };
          });
        return response;
      } catch (e: any) {
        //
      }
    },
    [dispatch],
  );
  return { execute };
};
